(function () {

   let data = {};
   let progressBarInstance = null;

   const steps = [{
      value: 19
   }, {
      value: 59
   }, {
      value: 99
   }];

   function initProgressBar() {
      console.log('Initialisiere Progress Bar...');

      if (typeof ProgressBar === 'undefined') {
         console.error('ProgressBar.js ist nicht geladen!');
         return false;
      }

      const progressElement = document.querySelector('#discount-progress');
      if (!progressElement) {
         console.error('#discount-progress Element nicht gefunden!');
         return false;
      }

      if (!progressBarInstance) {
         progressBarInstance = new ProgressBar.Line('#discount-progress', {
            strokeWidth: 4,
            easing: 'easeInOut',
            duration: 800,
            color: '#3f6045',
            trailColor: 'transparent',
            svgStyle: {
               width: '100%',
               height: '100%',
               borderRadius: '10px'
            },
         });
      }
      return true;
   }

   function updateProgressBar(cartData = null) {
      const rootUrl = window.Shopify ? window.Shopify.routes.root : '/';

      fetch(rootUrl + 'cart.js')
         .then((res) => {
            if (!res.ok) throw new Error('Cart fetch fehlgeschlagen');
            return res.json();
         })
         .then((cart) => {
            console.log('Cart Daten:', {
               totalPrice: cart.total_price / 100,
               originalTotalPrice: cart.original_total_price / 100,
               itemCount: cart.item_count,
            });

            const cartValue = cart.original_total_price / 100;
            const maxValue = steps[steps.length - 1].value;
            const fillPercent = Math.min(cartValue / maxValue, 1);

            if (progressBarInstance) {
               progressBarInstance.animate(fillPercent);
            } else {
               console.error('Progress Bar Instanz nicht vorhanden');
            }

            document.querySelectorAll('.step').forEach((step) => {
               const stepIcon = step.querySelector('.step-icon');
               const stepLabel = step.querySelector('.step-label');

               const threshold = parseFloat(step.dataset.threshold);
               const positionPercent = Math.min((threshold / maxValue) * 100, 100);

               if (stepIcon && stepLabel) {
                  const labelText = stepLabel.textContent.trim();
                  stepIcon.textContent = labelText;
               }

               step.style.left = `${positionPercent}%`;

               if (cartValue >= threshold) {
                  step.classList.add('active');
               } else {
                  step.classList.remove('active');
               }
            });
         })
         .catch((err) => {
            console.error('Cart fetch error:', err);
         });
   }

   const originalFetch = window.fetch;
   window.fetch = async function (...args) {
      const [resource, options] = args;
      const url = typeof resource === 'string' ? resource : resource.url;

      if (url.includes('/cart/')) {
         console.groupCollapsed('Abgefangener Fetch-Cart-API-Aufruf');
         console.log('URL:', url);
         console.log('Methode:', options?.method || 'GET');
         if (options?.body) {
            try {
               console.log('Request Body:', JSON.parse(options.body));
               const cartData = JSON.parse(options.body);
               updateProgressBar(cartData);
            } catch (e) {
               console.log('Request Body (raw):', options.body);
            }
         }
         console.groupEnd();
      }

      return originalFetch.apply(this, args);
   };

   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', function () {
       initProgressBar();
       updateProgressBar();
     });
   } else {
     initProgressBar();
     updateProgressBar();
   }
})();